module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', [_c('div', {
    staticClass: "blackBG"
  }), _vm._v(" "), _c('div', {
    staticClass: "onboarding"
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    staticClass: "video-p",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.lessonImage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "approve",
    on: {
      "click": _vm.closePop
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("OnBoardingModal.OnBoardingModal.start")) + "\n      ")])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b20649","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onBoardingModal/OnBoardingModal.vue
// module id = 261
// module chunks = 0 1 2 3 7